export default __webpack_public_path__ + "static/media/gofundme.36b6fe0c.svg";